// FILE: components/rewards/rewardPresets.ts
// Config cho từng loại reward popup. Thêm preset mới → thêm vào đây, không sửa RewardModal.

export type RewardType = "welcome_ref" | "welcome_plain" | "badge_earned" | "level_up";

export interface RewardPreset {
  /** Dùng để queue key + tracking */
  type: RewardType;
  /** Tiêu đề popup */
  title: string;
  /** Lời chào ngắn */
  subtitle: string;
  /** Nội dung body - dùng {amount} để insert số kim cương */
  body: string;
  /** Label nút CTA */
  ctaLabel: string;
  /** Route điều hướng sau khi bấm CTA (null = chỉ đóng modal) */
  ctaHref: string | null;
  /** Hiện block "+N 💎" to ở trung tâm? */
  showAmount: boolean;
  /** Burst pháo hoa khi mở modal */
  confetti: boolean;
  /** Màu gradient accent cho modal */
  accent: "gold" | "purple" | "teal";
}

export const REWARD_PRESETS: Record<RewardType, RewardPreset> = {
  welcome_ref: {
    type: "welcome_ref",
    title: "Đăng ký thành công!",
    subtitle: "Chào mừng bạn đến với JB AI",
    body: "Bạn vừa nhận được {amount} Kim cương quà tặng khởi nghiệp từ mã giới thiệu. Hãy dùng để mở khóa các bộ đề VIP nhé!",
    ctaLabel: "Tuyệt vời! Bắt đầu khám phá",
    ctaHref: "/explore",
    showAmount: true,
    confetti: true,
    accent: "gold",
  },
  welcome_plain: {
    type: "welcome_plain",
    title: "Chào mừng đến với JB AI!",
    subtitle: "Nền tảng ôn thi thông minh",
    body: "Khám phá các lộ trình, đề thi và công cụ AI giúp bạn học hiệu quả hơn.",
    ctaLabel: "Bắt đầu khám phá",
    ctaHref: "/explore",
    showAmount: false,
    confetti: false,
    accent: "teal",
  },
  badge_earned: {
    type: "badge_earned",
    title: "Bạn vừa đạt huy hiệu mới!",
    subtitle: "Thành tích được ghi nhận",
    body: "Tiếp tục học tập để mở khóa thêm nhiều huy hiệu khác.",
    ctaLabel: "Xem huy hiệu",
    ctaHref: "/badges",
    showAmount: false,
    confetti: true,
    accent: "purple",
  },
  level_up: {
    type: "level_up",
    title: "Lên cấp!",
    subtitle: "Bạn đã mở khóa tính năng mới",
    body: "Chúc mừng bạn đạt cấp độ mới. Tiếp tục phát huy nhé!",
    ctaLabel: "Tiếp tục",
    ctaHref: null,
    showAmount: false,
    confetti: true,
    accent: "teal",
  },
};